
import HomeEvent from "@/components/Home/HomeEvent.vue";
import {defineComponent} from "vue";

export default defineComponent({
  name: "HomeEvents",
  components: {HomeEvent},
  data(): {
    standardEvents: Array<{ href: string; title: string, date: string }>;
    vsrgEvents: Array<{ href: string; title: string, date: string }>;
  } {
    return {
      standardEvents: [
        {
          href: "#",
          title: "I passed the Google Professional ML Engineer Exam!",
          date: "7 Jul 2023"
        },
        {
          href: "#",
          title: "Last semester of school, will pause most hobbies! See you in July",
          date: "10 Mar 2023"
        },
      ],
      vsrgEvents: [
        {
          href: "https://opal-ai.streamlit.app/",
          title: "Deployed opal! My AI Score Prediction Service",
          date: "7 Mar 2023"
        },
        {
          href: "https://osu.ppy.sh/beatmapsets/1825212#mania/3745767",
          title: "Japanese Soul Brothers Released! Thanks for the support ' w')9",
          date: "10 Aug 2022"
        },
        {
          href: "/#/release",
          title: "Added 3 more maps to express",
          date: "13 Feb 2022"
        },
        {
          href: "/#/release",
          title: "New Map Pack: express",
          date: "9 Jan 2022"
        },
        {
          href: "https://osu.ppy.sh/beatmapsets/1647221#mania/3362200",
          title: "Shinbatsu Ranked!",
          date: "30 Dec 2021"
        },
        {
          href: "https://osu.ppy.sh/beatmapsets/1188950#mania/2477481",
          title: "xi - PEACE BREAKER Loved!",
          date: "14 Dec 2021"
        },
      ],
    };
  },
});
